export function getEpostUkCreditsAfter(total, currentCredits) {
  return currentCredits - total
}

export function isEpostLoading(value) {
  return value < 100
}

export function isEpostLoaded(value) {
  return value === 100
}
